export default "__VITE_ASSET__B$YbzE11__"